import Text from '~components/Text';
import useMedia from '~hooks/useMedia';

import * as S from './style';

export default function EmptyJobdom() {
  const { isMobile } = useMedia();

  return (
    <S.Wrapper>
      <S.Img src='https://image.wanted.co.kr/kreditjob/www/pencil.png' alt='pencil' />
      <S.TitleWrapper>
        <Text typography='bold150_B2'>아직 등록된 글이 없습니다.</Text>
      </S.TitleWrapper>
      <Text
        typography='midium150_B3'
        as='div'
        dangerouslySetInnerHTML={{
          __html: isMobile
            ? '이 기업의 연봉, 스톡옵션, 성과급 등에 대한</br>이야기를 남겨주세요.'
            : '이 기업의 연봉, 스톡옵션, 성과급 등에 대한 이야기를 남겨주세요.',
        }}
      />
    </S.Wrapper>
  );
}
